import { CloseSharp } from "@mui/icons-material";
import { IconButton, Stack } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import type { JSX } from "react";

type PropsType = {
  open: boolean;
  title?: string;
  content?: JSX.Element;
  action?: JSX.Element;
  onClose: () => void;
};

const CustomConfirmDialog = ({
  open,
  title,
  content,
  action,
  onClose,
}: PropsType) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      fullWidth
      maxWidth="sm"
    >
      <DialogTitle>
        <Stack
          useFlexGap
          direction={"row"}
          justifyContent={"space-between"}
          alignItems={"center"}
        >
          <div>{title}</div>
          <IconButton onClick={onClose} sx={{ color: "grey.950" }}>
            <CloseSharp />
          </IconButton>
        </Stack>
      </DialogTitle>
      <DialogContent>{content}</DialogContent>
      <DialogActions>{action}</DialogActions>
    </Dialog>
  );
};

export default CustomConfirmDialog;
